// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__305g3","signatureButtonsRight":"ModalSign_signatureButtonsRight__3gMM7"};